import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import React, { Fragment } from 'react';

type Props = {
  isMobile: boolean;
};

const NftLeftDetailsSkeleton: React.FC<Props> = ({ isMobile }) => {
  return (
    <Fragment>
      {!isMobile && (
        <Stack
          mb={4}
          height={'528px'}
          alignItems="center"
          justifyContent="center"
          bgcolor="#1A1A1A"
          borderRadius="12px"
          position="relative"
          overflow="hidden"
        >
          {/* Skeleton for NFT preview image */}
          <Skeleton
            variant="rectangular"
            width={40}
            height={40}
            sx={{ position: 'absolute', bottom: '10px', right: '10px', borderRadius: '30%' }}
          />

          {/* Skeleton for main NFT image */}
          <Skeleton variant="rectangular" width={256} height={144} sx={{ borderRadius: '6px' }} />
        </Stack>
      )}

      {/* Details Accordion Skeleton */}
      <Box
        sx={{
          mt: '12px',
          borderTop: '1px solid #54585F'
        }}
      >
        <Accordion defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon color="primary" />}
            aria-controls="panel3-content"
            id="panel3-header"
            sx={{ display: 'flex', alignItems: 'center', padding: '0' }}
          >
            <Skeleton variant="text" width={100} height={20} />
          </AccordionSummary>
          <AccordionDetails sx={{ textAlign: 'left', padding: '0' }}>
            {/* Skeletons for network info */}
            <Stack direction="row" alignItems="center" justifyContent="space-between" paddingTop={'8px'}>
              <Skeleton variant="text" width={80} height={20} />
              <Skeleton variant="text" width={100} height={20} />
            </Stack>

            {/* Skeletons for contract address */}
            <Stack direction="row" alignItems="center" justifyContent="space-between" paddingTop={'8px'}>
              <Skeleton variant="text" width={120} height={20} />
              <Skeleton variant="text" width={100} height={20} />
            </Stack>

            {/* Skeletons for token ID */}
            <Stack direction="row" alignItems="center" justifyContent="space-between" paddingTop={'8px'}>
              <Skeleton variant="text" width={80} height={20} />
              <Skeleton variant="text" width={100} height={20} />
            </Stack>
          </AccordionDetails>

          {/* Skeleton for View Metadata Action */}
          <AccordionActions sx={{ mt: '12px', padding: '0' }}>
            <Skeleton variant="text" width={100} height={20} />
          </AccordionActions>
        </Accordion>
      </Box>

      {/* Traits Accordion Skeleton */}
      <Box mb={3} sx={{ mt: '12px', borderTop: '1px solid #54585F' }}>
        <Accordion defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon color="primary" />}
            aria-controls="panel3-content"
            id="panel3-header"
            sx={{ display: 'flex', alignItems: 'center', padding: '0' }}
          >
            <Skeleton variant="text" width={100} height={20} />
          </AccordionSummary>
          <AccordionDetails sx={{ textAlign: 'left', padding: '0' }}>
            <Grid container spacing={2}>
              {Array.from({ length: 6 }).map((_, index) => (
                <Grid item xs={6} sm={4} key={index}>
                  <Box
                    sx={{
                      border: '1px solid #9E9E9E',
                      backgroundColor: '#232323',
                      borderRadius: '4px',
                      padding: '12px',
                      minHeight: '68px'
                    }}
                  >
                    <Skeleton variant="text" width={80} height={20} />
                    <Stack direction="row" alignItems="center" justifyContent="flex-start" paddingTop={'8px'}>
                      <Skeleton variant="text" width={60} height={20} />
                      <Skeleton variant="text" width={40} height={20} />
                    </Stack>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Box>
    </Fragment>
  );
};

export default NftLeftDetailsSkeleton;
